import * as React from "react";
const SvgHeadphones01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.965 16.5a1.465 1.465 0 1 0-2.93 0v2a1.465 1.465 0 1 0 2.93 0zm13-4.5a7.965 7.965 0 1 0-15.93 0v1.282a3.535 3.535 0 0 1 5 3.218v2a3.535 3.535 0 0 1-7.07 0V12C1.965 6.458 6.458 1.965 12 1.965S22.035 6.458 22.035 12v6.5a3.535 3.535 0 0 1-7.07 0v-2a3.535 3.535 0 0 1 5-3.218zm-2.93 6.5a1.465 1.465 0 1 0 2.93 0v-2a1.465 1.465 0 1 0-2.93 0z"
}));
export default SvgHeadphones01;
//# sourceMappingURL=Headphones01.js.map